import { createAsyncThunk } from '@reduxjs/toolkit';

import { addressService } from 'src/services/address';

import { setLoadingStatus } from '../app';
import { ICoreState } from '../types';

export const loadAddressOptions = createAsyncThunk<{
    districtes: string[];
    barris: string[];
    codiPostals: string[];
}, void, { state: ICoreState }>('address/loadOptions', async (_data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        dispatch(setLoadingStatus(true));
        const result = await addressService.getOptions();
        dispatch(setLoadingStatus(false));
        return result;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});
